import styled from 'styled-components';

export const Container = styled.div`
  background-color: #eaeaea;
  padding: 10px 20px;
  min-height: 200px;

  > form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 0;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
`;

export const DownloadContainer = styled.div`
  width: 100%;
`;


export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;